import moment from 'moment-timezone';
import { getAccountTimeFormat } from 'shared/utils';
import {
  AccountInfoType,
  CollectorChannelType,
  ColumnSettingsType,
  ContactListType,
  FormServFieldType,
} from '../../../shared/types';

export const getListsColumnSettings = ({
  accountInfo,
}: {
  accountInfo?: AccountInfoType;
}): ColumnSettingsType => ({
  label: {
    showInitial: true,
    disableReordering: true,
  },
  no_of_contacts: {
    showInitial: true,
    disableReordering: true,
    accessor: ({ contacts_count }: ContactListType) => contacts_count || 0,
  },
  created_by_id: {
    showInitial: true,
  },
  created_at: {
    showInitial: true,
    accessor: ({ created_at }: ContactListType) =>
      created_at
        ? moment(new Date(created_at))
            .tz(accountInfo?.timezone || moment.tz.guess())
            .format(getAccountTimeFormat(accountInfo))
        : '',
  },
  updated_at: {
    showInitial: true,
    accessor: ({ updated_at }: ContactListType) =>
      updated_at
        ? moment(new Date(updated_at))
            .tz(accountInfo?.timezone || moment.tz.guess())
            .format(getAccountTimeFormat(accountInfo))
        : '',
  },
  updated_by_id: {
    showInitial: true,
  },
});

export const listFields: FormServFieldType[] = [
  {
    id: 'label',
    name: 'label',
    label: 'lists.list_fields.list_name',
    type: 1,
  },
  {
    id: 'no_of_contacts',
    name: 'no_of_contacts',
    label: 'lists.list_fields.no_of_contact',
    type: 8,
  },
  {
    id: 'created_at',
    name: 'created_at',
    label: 'contacts.import_contact.default_fields.contact.created_at',
    type: 7,
  },
  {
    id: 'created_by_id',
    name: 'created_by_id',
    label: 'contacts.import_contact.default_fields.contact.creater_id',
    type: 1,
  },
  {
    id: 'updated_at',
    name: 'updated_at',
    label: 'contacts.import_contact.default_fields.contact.updated_at',
    type: 7,
  },
  {
    id: 'updated_by_id',
    name: 'updated_by_id',
    label: 'contacts.import_contact.default_fields.contact.updater_id',
    type: 1,
  },
];

export const AllCollectorChannels: Record<CollectorChannelType, string> = {
  EMAIL: 'Email',
  EMAIL_EMBED: 'Email embed',
  WEB_APP: 'Web',
  WEB_LINK: 'Link',
  FACEBOOK_MESSENGER: 'Facebook Messenger',
  INSTAGRAM: 'Instagram',
  MOBILE_SDK: 'Mobile SDK',
  WEB_WIDGET: 'Web Widget',
  WHATSAPP: 'WhatsApp',
};
